import { render } from "./BtnGroupModeMobile.vue?vue&type=template&id=6f047b7b&scoped=true"
import script from "./BtnGroupModeMobile.vue?vue&type=script&lang=js"
export * from "./BtnGroupModeMobile.vue?vue&type=script&lang=js"

import "./BtnGroupModeMobile.vue?vue&type=style&index=0&id=6f047b7b&scoped=true&lang=css"

import exportComponent from "/home/dr/PhpstormProjects/anh/vue/scheduleweek/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f047b7b"]])

export default __exports__